import { useCallback, useState } from "react";
import {
  createWebSubscriptionSetupIntent,
  WebSubscriptionCheckoutSessionPayload,
  WebSubscriptionSetupIntentResponse,
} from "../api/paymentApi";
import {
  attachPendingGuestStripeSubscriptionSetupNonce,
  persistPendingGuestStripeSubscriptionSetup,
} from "../utils/pendingGuestStripeSubscriptionSetup";

export type PendingStripeSubscriptionSetupIntent =
  WebSubscriptionSetupIntentResponse & {
    payload: WebSubscriptionCheckoutSessionPayload;
  };

export function useStripeCheckoutSubscriptionSetup() {
  const [waiting, setWaiting] = useState(false);
  const [error, setError] = useState<string>();
  const [setupIntent, setSetupIntent] =
    useState<PendingStripeSubscriptionSetupIntent>();

  const startSetupCheckout = useCallback(
    async (payload: WebSubscriptionCheckoutSessionPayload) => {
      setError(undefined);
      setWaiting(true);
      persistPendingGuestStripeSubscriptionSetup(payload);

      try {
        const response = await createWebSubscriptionSetupIntent(payload);
        const results = response.data.payload.results;
        if (results.client_nonce) {
          attachPendingGuestStripeSubscriptionSetupNonce(results.client_nonce);
        }
        setSetupIntent({
          ...results,
          payload,
        });
      } catch (checkoutError) {
        throw checkoutError;
      } finally {
        setWaiting(false);
      }
    },
    [],
  );

  const clearSetupIntent = useCallback(() => {
    setSetupIntent(undefined);
  }, []);

  return {
    startSetupCheckout,
    waiting,
    error,
    setError,
    setupIntent,
    clearSetupIntent,
  };
}
